import { WeatherForecast } from '@/models/WeatherForecast'
import { WeatherForecastRepository } from '@/repositories/weather-forecast-repository'
import { defineStore } from 'pinia'
import moment from 'moment'

const storeKey = 'weather-forecast'

type Store = {
  updated: string
  areaList: {
    name: string
    weatherAreaId: string
  }[]
  weatherForecastList: {
    [key in string]: WeatherForecast
  }
}

const repository = new WeatherForecastRepository()

export const useWeatherForecastStore = defineStore(storeKey, {
  state: () =>
    ({
      updated: '2000-01-01',
      areaList: [
        {
          name: '川崎市',
          weatherAreaId: 'JWA_kawasaki-14130',
        },
        {
          name: '川崎市川崎区',
          weatherAreaId: 'JWA_kawasaki-14130_01',
        },
        {
          name: '川崎市幸区',
          weatherAreaId: 'JWA_kawasaki-14130_06',
        },
        {
          name: '川崎市中原区',
          weatherAreaId: 'JWA_kawasaki-14130_02',
        },
        {
          name: '川崎市高津区',
          weatherAreaId: 'JWA_kawasaki-14130_05',
        },
        {
          name: '川崎市宮前区',
          weatherAreaId: 'JWA_kawasaki-14130_04',
        },
        {
          name: '川崎市多摩区',
          weatherAreaId: 'JWA_kawasaki-14130_03',
        },
        {
          name: '川崎市麻生区',
          weatherAreaId: 'JWA_kawasaki-14130_07',
        },
      ],
      weatherForecastList: {},
    } as Store),

  actions: {
    async fetch() {
      // 更新が１0分前ならAPIの問い合わせを行わない
      console.log(
        moment().add(-10, 'minute').toISOString(),
        this.updated,
        moment().add(-10, 'minute').toISOString() < this.updated
      )
      if (this.updated && moment().add(-10, 'minute').toISOString() < this.updated) {
        return
      }

      for (const area of this.areaList) {
        const data = await repository.fetch(area.weatherAreaId)
        this.weatherForecastList[data.weatherAreaId] = data
      }
      this.updated = moment().toISOString()
    },
  },
})
